DOMReady( function(){
  [... document.querySelectorAll('.print-coloriage')].map( printbtn => {
    printbtn.addEventListener( 'click', (event) => {
      let src = printbtn.dataset.imgsrc;
      let title = printbtn.dataset.imgtitle;
      let format = ""
      let srcheight = printbtn.dataset.imgheight;
      let srcwidth = printbtn.dataset.imgwidth;

      if( srcwidth >  srcheight )
      {
        format = '<style type="text/css" media="print">@page { size: landscape; }</style>';
      }

      let printwidth = srcwidth + 200;
      let printheight = srcheight + 200;

      let zone = format + '<p style="width:100%"><img src="'+src+'" style="width:85%"/></p><p style="width:100%;text-align:right"><img src="'+document.querySelector('.navbar-brand img').getAttribute('src')+'" width="80px" class="img-fluid"/></p>';
      let fen = window.open("", "", "height="+printheight+", width="+printwidth+",menubar=0,status=0");
      // style du popup
      fen.document.body.style.color = '#000000';
      fen.document.body.style.backgroundColor = '#FFFFFF';
      fen.document.body.style.padding = "10px";
      fen.document.body.style.textAlign = "center";

      // Ajout des données a imprimer
      fen.document.title = title;
      fen.document.body.innerHTML += " " + zone + " ";
      setTimeout(function () { fen.window.print(); }, 500);
      fen.window.onfocus = function () { setTimeout(function () { fen.window.close(); }, 500); }
    });
  });
});
